import { render, staticRenderFns } from "./botsplash.vue?vue&type=template&id=7299ee42&"
import script from "./botsplash.vue?vue&type=script&lang=js&"
export * from "./botsplash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports